// import firebase from 'firebase';
// import 'firebase/firestore';

// import { FIREBASE_CONFIG } from '../config';
// import { convertDocument } from './helper';

// export const firebaseApp = firebase.initializeApp(FIREBASE_CONFIG);
// export const firebaseAuth = firebaseApp.auth();
// export const firestore = firebase.firestore();
// export const firebaseStorage = firebaseApp.storage ? firebaseApp.storage() : () => 1;

// const buildUser = (userInfo) => {
//   return firestore.doc(`users/${userInfo.uid}`).get().then(convertDocument)
//     .then((u) => {
//       if (!u) {
//         throw new Error('No accounts are associated with this user');
//       }
//       return u;
//     })
//     .then((u) => {
//       return Promise.all(_.keys(u.accounts).map((accountId) => {
//         return Promise.all([
//           firestore.doc(`accounts/${accountId}`).get().then(convertDocument),
//           firestore.doc(`accounts/${accountId}/employees/${userInfo.uid}`).get().then(convertDocument),
//         ])
//           .then(([account, employee]) => {
//             u.accounts[accountId] = account;
//             u.accounts[accountId].employee = employee;
//             return u;
//           });
//       })).then(() => {
//         return u;
//       });
//     })
//     .then((u) => _.assign({}, _.pick(userInfo, ['uid']), _.pick(u, ['accounts'])))
//     .then((ui) => {
//       // if (typeof localStorage !== 'undefined') {
//         localStorage.setItem('userInfo', JSON.stringify(ui));
//         localStorage.setItem('accounts', JSON.stringify(ui.accounts));
//       // }
//       return ui;
//     });
// };

import AccountsService from './AccountsService';

/**
 * upload employee image.
 *
 * @param path {!string|string}
 * @returns {!firebase image url|firebase image url}
 */
// const uploadImage = (uploadPath, filename, file) => {
//   const storageRef = firebaseStorage.ref(uploadPath).child(filename);
//   const uploadFile = storageRef.put(file);
//   return new Promise((resolve, reject) => {
//     uploadFile.on('state_changed', () => {}, (error) => {
//       console.error('Unable to upload customer image', error);
//       reject(error);
//     }, () => {
//       // Handle successful uploads on complete
//       // For instance, get the download URL: https://firebasestorage.googleapis.com/...
//       const downloadURL = uploadFile.snapshot.downloadURL;
//       console.log('download url:' , downloadURL);
//       resolve(downloadURL);
//     });
//   });
// };


// const FireBaseTools = {
//
//   /**
//    * Return an instance of a firebase auth provider based on the provider string.
//    *
//    * @param provider
//    * @returns {firebase.auth.AuthProvider}
//    */
//   getProvider: (provider) => {
//     switch (provider) {
//       case 'email':
//         return new firebase.auth.EmailAuthProvider();
//       default:
//         throw new Error('Provider is not supported!!!');
//     }
//   },
//
//   /**
//    * Login with provider => p is provider "email", "facebook", "github", "google", or "twitter"
//    * Uses Popup therefore provider must be an OAuth provider. EmailAuthProvider will throw an error
//    *
//    * @returns {any|!firebase.Thenable.<*>|firebase.Thenable<any>}
//    */
//   loginWithProvider: (p) => {
//     const provider = FireBaseTools.getProvider(p);
//     return firebaseAuth.signInWithPopup(provider).then(firebaseAuth.currentUser).catch((error) => ({
//       errorCode: error.code,
//       errorMessage: error.message,
//     }));
//   },
//
//   /**
//    * Log the user in using email and password
//    *
//    * @param user
//    * @returns {any|!firebase.Thenable.<*>|firebase.Thenable<any>}
//    */
//   loginUser: (user, isScript) => {
//     return firebaseAuth.signInWithEmailAndPassword(user.email, user.password)
//       .then((userInfo) => {
//         // console.log('userInfo', userInfo);
//         return userInfo;
//       })
//       // .then(buildUser)
//       // .then((user) => {
//       //   return user;
//       //   })
//       // .then((userInfo) => firebaseDb.ref(`/users/${userInfo.uid}/accountId`).once('value')
//       //   .then((accountId) => accountId.data()).then((accountId) => {
//       //     return firebaseDb.ref(`/accounts/${accountId}/info`).once('value')
//       //       .then((snap) => snap.data()).then((accountInfo) => {
//       //         if (!isScript) {
//       //           localStorage.setItem('accountId', accountId);
//       //           localStorage.setItem('account', JSON.stringify(_.assign({ id: accountId }, accountInfo)));
//       //         }
//       //         return userInfo;
//       //       });
//       //   }))
//       .catch((error) => {
//         console.error('Login User', error);
//         throw new Error({
//           code: error.code,
//           message: error.message || error,
//         });
//         // throw error;
//       });
//   },
//   /**
//    * Register a user with email and password
//    *
//    * @param user
//    * @returns {any|!firebase.Thenable.<*>|firebase.Thenable<any>}
//    */
//   registerUser: (user) => firebaseAuth.createUserWithEmailAndPassword(user.email, user.password)
//     .then((userInfo) => userInfo),
//
//   /**
//    * Sign the user out
//    *
//    * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
//    */
//   logoutUser: () => firebaseAuth.signOut().then(() => {
//     console.log('clearing local storage');
//     localStorage.removeItem('userInfo');
//     localStorage.removeItem('account');
//   }).then(() => ({
//     success: 1,
//     message: 'logout',
//   })),
//
//   // /**
//   //  * Retrieve the current user (Promise)
//   //  * @returns {Promise}
//   //  */
//   fetchUser: () => new Promise((resolve, reject) => {
//     const unsub = firebaseAuth.onAuthStateChanged((user) => {
//       unsub();
//       if (!user) {
//         return reject('User is not logged in');
//       }
//       return resolve(user);
//     }, (error) => {
//       reject(error);
//     });
//   }),
//     // .then(buildUser),
//
//   /**
//    * Update a user's profile data
//    *
//    * @param u
//    * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
//    */
//   updateUserProfile: (u) => firebaseAuth.currentUser.updateProfile(u).then(() => firebaseAuth.currentUser, (error) => ({
//     errorCode: error.code,
//     errorMessage: error.message,
//   })),
//
//   /**
//    * Update a user's email address
//    *
//    * @param email
//    * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
//    */
//   updateUserEmail: (email) => firebaseAuth.currentUser.updateEmail(email).then(() => firebaseAuth.currentUser)
//     .catch((error) => {
//       console.error('===========email update error==========>', error.message);
//       return ({
//         errorCode: error.code,
//         errorMessage: error.message,
//       });
//     }),
//
//   /**
//    * Reset the password given the specified email
//    *
//    * @param email {string}
//    * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
//    */
//   resetPasswordEmail: (email) => firebaseAuth.sendPasswordResetEmail(email).then(() => ({
//     message: 'Email sent',
//   })),
//
//   /**
//    * Update the user's password with the given password
//    *
//    * @param newPassword {string}
//    * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
//    */
//   changePassword: (newPassword) => firebaseAuth.currentUser.updatePassword(newPassword)
//     .then((user) => user),
//
//   /**
//    * Send an account email verification message for the currently logged in user
//    *
//    * @returns {!firebase.Promise.<*>|firebase.Thenable<any>|firebase.Promise<any>|!firebase.Thenable.<*>}
//    */
//   sendEmailVerification: (user) => {
//     return Promise.resolve(1)
//       .then(() => {
//         if (user) {
//           return firebaseAuth.signInWithEmailAndPassword(user.email, user.password)
//             .then((u) => u.sendEmailVerification())
//             .then(() => firebaseAuth.signOut());
//         } else if (firebaseAuth.currentUser) {
//           return firebaseAuth.currentUser.sendEmailVerification()
//             .then(firebaseAuth.signOut);
//         } else {
//           return Promise.reject({
//             message: 'User is not logged in',
//           });
//         }
//       })
//       .then(() => ({
//         message: 'Email sent',
//       }));
//
//     // if (firebaseAuth.currentUser) {
//     //   return firebaseAuth.currentUser.sendEmailVerification().then(() => ({
//     //       message: 'Email sent',
//     //     })
//     //   );
//     // } else {
//     //   return Promise.reject({
//     //     message: 'User is not logged in',
//     //   });
//     // }
//   },
//
//   // /**
//   //  * Get the firebase database reference.
//   //  *
//   //  * @param path {!string|string}
//   //  * @returns {!firebase.database.Reference|firebase.database.Reference}
//   //  */
//   // getDatabaseReference: (path) => firebaseDb.ref(path),
//
//   /**
//    * upload employee image.
//    *
//    * @param path {!string|string}
//    * @returns {!firebase image url|firebase image url}
//    */
//   uploadEmployeeImage: (filename, file) => {
//     return uploadImage(getAccountPath('employees'), filename, file);
//   },
//
//   /**
//    * upload employee image.
//    *
//    * @param path {!string|string}
//    * @returns {!firebase image url|firebase image url}
//    */
//   uploadCustomerImage: (filename, file) => {
//     return uploadImage(getAccountPath('customers'), filename, file);
//   },
//
//   verifyPasswordResetCode: (code) => firebase.auth().verifyPasswordResetCode(code)
//     .then((email) => email),
//   setNewPassword: (code, newPassword) => firebase.auth().confirmPasswordReset(code, newPassword)
//     .then(() => 'success'),
//   applyVerificationCode: (code) => firebase.auth().applyActionCode(code)
//     .then(() => 'success'),
// };

function getAccountId() {
  const account = AccountsService.getAccount();
  return account ? account.id : null;
}

// TODO move elsewhere
function getAccountPath(name, id) {
  const accountId = getAccountId();
  const p = `/v1/accounts/${accountId}${!name.startsWith('/') ? '/' : ''}${name}${id ? `/${id}` : ''}`;
  return p;
}

// function getIdToken() {
//   console.log('getIdToken', firebase.auth().currentUser);
//   if (firebase.auth().currentUser) {
//     return firebase.auth().currentUser.getIdToken()
//       .then((token) => {
//         console.log('get current user token', token);
//         return token;
//       });
//   }
//
//   return Promise.reject('no auth token');
//
//   // const token = localStorage.getItem('id_token');
//   // return Promise.resolve(token);
// }

export {
  // FireBaseTools as default,
  getAccountPath,
  getAccountId,
  // getIdToken,
};



// WEBPACK FOOTER //
// ./src/utils/firebase.js